/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';
import { apiHelpers } from 'ui-permit/shared-components/utils/async';
import {
    availability,
    permit,
    recarea,
    reservations,
    reservation,
    unpaidReservation,
    lotteries,
    lottery,
    lotteryIssuance,
    updLotteryIssuance,
    unpaidLotteryIssuance,
    getLotteryIssuance,
    cancelIssuance,
    lotteryIssuanceWinner,
    seasons,
} from './endpoints';

const { get, getWithAuth, postWithAuth } = apiHelpers(SecurityHelper);

// Permit
export const fetchPermit = (id: string) => get(permit(id));
export const fetchRecarea = (recId: string) => getWithAuth(recarea(recId));

// Availability
export const fetchAvailability = (params: any) => get(availability(params));

// Reservations
export const addReservation = (params: any) =>
    postWithAuth(reservations(params.permit_id), params);
export const updateReservation = (params: any) =>
    postWithAuth(reservation(params.permit_id, params.id), params);
export const fetchReservation = (permitId: string, issuanceId: string) =>
    getWithAuth(reservation(permitId, issuanceId));
export const fetchUnpaidReservation = (permitId: string, issuanceId: string) =>
    getWithAuth(unpaidReservation(permitId, issuanceId));

// Lotteries
export const fetchLotteriesContent = (permitId: string) =>
    getWithAuth(lotteries(permitId));
export const fetchLottery = (permitId: string, lotteryId: string) =>
    getWithAuth(lottery(permitId, lotteryId));

// Lottery Issuances
export const postLotteryIssuance = (issuance: any) =>
    postWithAuth(lotteryIssuance(), issuance);
export const updateLotteryIssuance = (params: any) =>
    postWithAuth(updLotteryIssuance(params.id), params);
export const fetchUnpaidLotteryIssuance = (
    permitId: string,
    issuanceId: string,
    useNewMuxPath: boolean
) => getWithAuth(unpaidLotteryIssuance(permitId, issuanceId, useNewMuxPath));
export const fetchLotteryIssuance = (permitId: string, issuanceId: string) =>
    getWithAuth(getLotteryIssuance(permitId, issuanceId));
export const cancelLotteryIssuance = (
    permitId: string,
    issuanceId: string,
    useNewMuxPath: boolean
) => postWithAuth(cancelIssuance(permitId, issuanceId, useNewMuxPath));
export const acceptWinningLotteryIssuance = (
    permitId: string,
    issuanceId: string,
    useNewMuxPath: boolean
) => postWithAuth(lotteryIssuanceWinner(permitId, issuanceId, useNewMuxPath));
// Seasons
export const fetchSeasons = (data: any) => getWithAuth(seasons(data));
